// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__d8N-C","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__S8ElP"};